import { render, staticRenderFns } from "./ScheduledProjectsPage.vue?vue&type=template&id=176ec5e2&scoped=true"
import script from "./ScheduledProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ScheduledProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledProjectsPage.vue?vue&type=style&index=0&id=176ec5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ec5e2",
  null
  
)

export default component.exports